import React from 'react';
import { Box, Typography, Button, Divider, useTheme } from '@mui/material';
import { Megaphone } from 'lucide-react';

const WHATSAPP_NUMBER = '5548991094459';
const WHATSAPP_MESSAGE = encodeURIComponent(
  'Olá, gostaria de saber mais sobre o projeto de gestão de marketing.',
);
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

export default function MarketingHome() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', py: 2 }}>
      <Box sx={{ textAlign: 'center', mb: 5 }}>
        <Box
          sx={{
            display: 'inline-flex',
            p: 2,
            borderRadius: '50%',
            backgroundColor: isDark ? 'primary.dark' : '#e3f2fd',
            color: 'primary.main',
            mb: 2,
          }}
        >
          <Megaphone size={40} />
        </Box>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Gestão de Marketing para Clínicas
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 3, fontWeight: 400 }}>
          Quer atrair mais pacientes para a sua clínica?
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => window.open(WHATSAPP_URL, '_blank')}
          sx={{ px: 4, py: 1.5, fontSize: '1rem' }}
        >
          Saiba Mais
        </Button>
      </Box>

      <Divider sx={{ mb: 3 }} />

      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          O problema que resolvemos
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Se você já se perguntou alguma dessas coisas, você não está sozinho:
        </Typography>
        <Box component="ul" sx={{ pl: 3, mb: 3 }}>
          {[
            'Como fazer com que os pacientes saibam que a minha clínica existe?',
            'Como ser encontrado por quem está procurando exatamente o que eu faço?',
            'Como me tornar referência na minha especialidade na minha cidade?',
            'Por que meu consultório está vazio enquanto vejo outras clínicas cheias?',
            'Preciso indicação de paciente para crescer — ou existe outro caminho?',
          ].map((q, i) => (
            <Typography
              key={i}
              component="li"
              variant="body1"
              color="text.secondary"
              sx={{ mb: 1, fontStyle: 'italic' }}
            >
              &quot;{q}&quot;
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Essas perguntas têm uma resposta em comum:{' '}
          <strong>aparecer no momento certo, para a pessoa certa</strong>.
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
          Profissionais excelentes perdem pacientes todos os dias porque não aparecem quando alguém
          pesquisa pelo procedimento que realizam.
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Enquanto você atende, alguém em Chapecó está digitando{' '}
          <strong>&quot;onde fazer tratamento de canal&quot;</strong> — e encontrando outra clínica.
        </Typography>
      </Box>
    </Box>
  );
}
